import React, { memo, useCallback, useMemo, useState } from 'react'

import { FiltersSidebar, Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number } from 'prop-types'

import { setDatePublished } from 'Pods/SearchPage/Store/actions/datePublished'
import { DATE_PUBLISHED } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import I18n from 'Pods/Shared/I18n'

import { datePublishedFiltersConfig } from './constants'

const translate = (key) => I18n.t(key, { ns: 'rails' })

function DatePublishedContent({ limit = 0, hideShowMore = true }) {
  const datePublished = useSearchPageStore(state => state.datePublished ?? DATE_PUBLISHED.ALL_TIME)
  const [showAll, setShowAll] = useState(false)
  // limit=0 tells FiltersGroup to show all items (0 || initFilters.length = all)
  const effectiveLimit = !hideShowMore && showAll ? 0 : limit

  const handleFilterChange = useCallback((_, value) => {
    setDatePublished(value)
  }, [])

  const selectedFilters = useMemo(() => [datePublished], [datePublished])

  const filters = useMemo(() => datePublishedFiltersConfig.map((group) => ({
    ...group,
    filters: group.filters.map(({ value, labelKey }) => ({
      value,
      label: translate(`search_page.filters.date_published.${labelKey}`),
    })),
  })), [])

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={filters}
        selectedFilters={selectedFilters}
        onFiltersChange={handleFilterChange}
        limit={effectiveLimit}
        useRadio
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
      {!hideShowMore && (
        <Button
          type="ghost-primary"
          customClass="filter-wrapper__show-more cgt-link-primary"
          onClick={() => setShowAll(value => !value)}
        >
          {translate(`search_page.filters.date_published.${showAll ? 'show_less' : 'show_more'}`)}
        </Button>
      )}
    </>
  )
}

DatePublishedContent.propTypes = {
  limit: number,
  hideShowMore: bool,
}

export default memo(DatePublishedContent)
